export default "__VITE_ASSET__6UuXRDGw__"